import React from 'react';
import { MapPin, Clock, Phone, Mail } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const LocationInfo = () => {
  const locationDetails = [
    {
      icon: MapPin,
      title: 'Headquarters',
      content: 'Dublin, Ireland',
      description: 'Serving clients across Europe and globally'
    },
    {
      icon: Clock,
      title: 'Business Hours',
      content: 'Monday - Friday: 9:00 AM - 6:00 PM IST',
      description: '24-hour response guarantee for all inquiries'
    },
    {
      icon: Phone,
      title: 'Phone',
      content: '+353 1 XXX XXXX',
      description: 'Direct line to our consultation team'
    },
    {
      icon: Mail,
      title: 'Email',
      content: 'contact@northstaranalytics.eu',
      description: 'We typically respond within 2 hours'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Visit or Contact Us
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Based in Dublin, serving organizations worldwide with data strategy excellence
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {locationDetails?.map((detail, index) => {
            const Icon = detail?.icon;
            return (
              <div 
                key={index} 
                className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow duration-300"
              >
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                    <Icon className="w-6 h-6 text-blue-600" />
                  </div>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {detail?.title}
                </h3>
                <p className="text-gray-900 font-medium mb-2">
                  {detail?.content}
                </p>
                <p className="text-sm text-gray-600">
                  {detail?.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Map placeholder */}
        <div className="mt-12 bg-white rounded-lg shadow-md overflow-hidden">
          <div className="aspect-w-16 aspect-h-9 bg-gray-200 flex items-center justify-center">
            <div className="text-center p-8">
              <MapPin className="w-12 h-12 text-gray-400 mx-auto mb-4" />
              <p className="text-gray-600">
                Dublin City Centre Location
              </p>
              <p className="text-sm text-gray-500 mt-2">
                Exact address provided upon consultation booking
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationInfo;